import { css } from 'aphrodite';
import { styleSheet } from './styles';

/**
 * Inline error message for a form field.
 * Shared by `CustomSurveyResponseForm/index.tsx` (custom-property fields via `renderField`),
 * `ContactInfoStep` (contact-info fields), and the shared `FileUpload` component,
 * so the style logic is defined once.
 */
export const ErrorMessage = ({ message }: { message: string }) => (
	<p className={`${css(styleSheet.errorMessage)} ${css(styleSheet.noMargin)}`}>{message}</p>
);
